function urlHasParam(paramName)
{
    var url = window.location.href;

    if(url.indexOf('?' + paramName + '=') != -1)
    {
        return true;
    }
    else
    {
        if(url.indexOf('&' + paramName + '=') != -1)
        {
            return true;
        }
    }
    return false
}
